import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Switch,
  Grid,
  Paper,
  CardContent,
  Typography,
  Stack,
  ButtonBase
} from "@mui/material";
import snipnchipLogo from "../../img/snipnchip_logo.png";
import scissorsIcon from "../../img/scissors.png";
import chipIcon from "../../img/spca-sc.png";
import catImg from "../../img/catball.png";
import chipImg from "../../img/chip.png";
import chipxImg from "../../img/chipx.png";
import scissorsIcon1 from "../../img/scissors1.png";
let link =
  "https://desexing.spca.nz/images/assets/1586/1/Voucher%20Terms%20and%20Conditions.pdf";

export default function StartPage({
  setStep,
  microchipOnly,
  setMicrochipOnly,
  onOption,
  initialOption
}) {
  const [acceptTerms, setAcceptTerms] = React.useState(false);
  const [selectedOption, setSelectedOption] = useState(null); // 'snip' | 'microchip'
  const [logoUrl, setLogoUrl] = useState(null);
  const [showInitialButtons, setShowInitialButtons] = useState(true);
  const [confirmDesexed, setConfirmDesexed] = useState(false);

  async function fetchSponsorImages() {
    try {
      const baseUrl = process.env.REACT_APP_BASE_API_URL;
      const response = await fetch(`${baseUrl}/api/azurefiles/list-images`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      const firstImage =
        data.images && data.images.length > 0 ? data.images[0] : null;
      setLogoUrl(firstImage);
    } catch (error) {
      console.error("Error fetching sponsor images:", error);
    }
  }

  useEffect(() => {
    fetchSponsorImages();
    if (initialOption) {
      setShowInitialButtons(false);
      setSelectedOption(initialOption);
      setMicrochipOnly?.(initialOption === "microchip");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialOption]);

  const handleInitialClick = (opt) => {
    onOption?.(opt);
    setShowInitialButtons(false);
    setSelectedOption(opt);
    setMicrochipOnly?.(opt === "microchip");
    setConfirmDesexed(false);
    window.gtag?.("event", "action", {
      category: "User",
      action: `Selected option: ${opt}`
    });
  };

  // analytics on mount
  useEffect(() => {
    window.gtag?.("set", "page_path", "#0 - Landing page");
    window.gtag?.("event", "page_view");
    window.gtag?.("event", "action", {
      category: "User",
      action: "Loaded start page"
    });
  }, []);

  const canApply =
    acceptTerms && (selectedOption !== "microchip" || confirmDesexed === true);

  return (
    <div className={"hero"}>
      {/* Back Button - only show when not on initial choice cards */}
      {!showInitialButtons && (
        <Box sx={{ position: 'absolute', top: 24, left: 24 }}>
          <Button variant="outlined" color="primary" onClick={() => window.location.reload()}>
            Back
          </Button>
        </Box>
      )}
      {showInitialButtons ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minHeight: "100vh",
            pt: { xs: 6, md: 8 },
            px: 2
          }}
        >
   
          {/* Intro copy (matches Image-2 tone) */}
          <Stack spacing={2} sx={{ maxWidth: 980, textAlign: "center", mb: 2 }}>
            <Typography variant="h5" fontWeight={700}>
              We’re excited to offer Snip ‘n’ Chip vouchers to help lower the
              number of unwanted cats in Aotearoa New Zealand.
            </Typography>
            <Typography variant="h6" fontWeight={500}>
              A big thank you to our generous supporters and participating
              veterinary clinics for making this possible.
            </Typography>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ mt: 1, mb: 1 }}
            >
              Select the type of voucher you require:
            </Typography>
          </Stack>

          {/* Two blue cards */}
          <Grid container spacing={3} sx={{ maxWidth: 980 }}>
            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
              <Box sx={{ width: "100%" }}>
                <ChoiceCardBlue
                  onClick={() => handleInitialClick("snip")}
                  title="Snip ‘n’ Chip"
                  bullets={[
                    "Desex and microchip voucher",
                    "Includes NZCAR microchip registration",
                    "$30 per cat, paid to the vet clinic"
                  ]}
                  dataTestid="card-snc"
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
              <Box sx={{ width: "100%" }}>
                <ChoiceCardBlue
                  onClick={() => handleInitialClick("microchip")}
                  title="Microchip Only"
                  bullets={[
                    "For cats already desexed",
                    "Includes NZCAR microchip registration",
                    "$30 per cat, paid to the vet clinic"
                  ]}
                  dataTestid="card-microchip"
                />
              </Box>
            </Grid>
          </Grid>

          {/* Cat, yarn, cat row at the bottom */}
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "flex-end", mt: 6 }}>
            <img src={catImg} alt="Kitten" style={{ height: 100, marginRight: 16 }} />
          </Box>
        </Box>
      ) : (
        <>
          <Stack spacing={2} sx={{ maxWidth: 1000, mx: "auto", px: 2, pt: 4 }}>
            <h2 className={"h2-bold"}>
              We’re excited to offer Snip’n’Chip to help lower the number of
              unwanted animals in New&nbsp;Zealand.
            </h2>

            <h2>
              Making desexing accessible is important to us and we want to assist
              owners who cannot afford to get their pet desexed. This is why we
              offer this service at a fraction of the cost. Standard Snip ‘n’ Chip
              vouchers are $30 per animal (paid to the clinic, non-refundable).
            </h2>

            <h2>
              A big thank you to our generous supporters and participating
              veterinary clinics for making this possible.
            </h2>

            {selectedOption === "microchip" && (
              <InfoPanel
                title="Microchip Only Voucher"
                items={[
                  "This voucher does not include desexing.",
                  "You can proceed only if your cat is already desexed.",
                  "Vet clinics accepting Microchip Only vouchers will be listed for you in the next section."
                ]}
              />
            )}

            <div style={{ margin: "0 auto", textAlign: "center" }}>
              <ShowTermsAcceptance
                acceptTerms={acceptTerms}
                setAcceptTerms={setAcceptTerms}
              />
              {selectedOption === "microchip" && (
                <FormControlLabel
                  sx={{ mt: 1 }}
                  control={
                    <Switch
                      checked={confirmDesexed}
                      onChange={(e) => setConfirmDesexed(e.target.checked)}
                    />
                  }
                  label={
                    <>
                      I confirm my animal is <strong>already desexed</strong>.
                    </>
                  }
                />
              )}
            </div>

            <div style={{ textAlign: "center" }}>
              <Button
                onClick={() => {
                  window.gtag?.("event", "action", {
                    category: "User",
                    action: "Clicked apply now"
                  });
                  setStep(1);
                }}
                size="small"
                sx={{ fontSize: "1.6em", fontWeight: 600, m: 1 }}
                variant="contained"
                disabled={!canApply}
              >
                Apply now to secure your spot
              </Button>
            </div>

            <div className={"content-small"}>
              The information you provide will be given to the Veterinary Clinic
              you have selected. This information will be used to help with
              bookings. For more information on our privacy policy please visit
              our website{" "}
              <a
                href={"https://www.spca.nz/privacy"}
                target={"_blank"}
                rel="noreferrer"
              >
                https://www.spca.nz/privacy
              </a>
              .
            </div>
          </Stack>
        </>
      )}

      <p style={{ textAlign: "center", marginTop: 24 }}>
        Lost your voucher email?{" "}
        <a href="#" onClick={() => window.alert("Handle lost voucher logic here")}>
          Click here
        </a>
      </p>

      <div style={{ textAlign: "center", marginTop: "2em" }}>
        {logoUrl && (
          <img
            src={logoUrl}
            alt="SPCA Bottom Logo"
            style={{ maxWidth: "200px", height: "auto" }}
          />
        )}
      </div>
    </div>
  );
}

/** ---------- Subcomponents ---------- */

function ChoiceCardBlue({ title, bullets, onClick, dataTestid, cornerEmoji }) {
  return (
    <ButtonBase
      onClick={onClick}
      data-testid={dataTestid}
      focusRipple
      component="div"
      sx={{
        width: "100%",
        display: "block",
        textAlign: "left",
        borderRadius: 3,
        position: "relative",
        cursor: "pointer"
      }}
      aria-label={title}
      role="button"
    >
      <Paper
        elevation={6}
        sx={{
          borderRadius: 3,
          bgcolor: "primary.main",
          color: "#fff",
          p: 3,
          "&:hover": { transform: "translateY(-2px)" },
          transition: "transform 120ms ease"
        }}
      >
        <CardContent sx={{ p: 0 }}>
          <Typography variant="h5" fontWeight={800} gutterBottom align="center">
            {title}
          </Typography>

          <Box component="ul" sx={{ m: 0, mt: 1, pl: 3 }}>
            {bullets.map((t, i) => (
              <Typography
                key={i}
                component="li"
                variant="body1"
                sx={{ lineHeight: 1.7 }}
              >
                {t}
              </Typography>
            ))}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* Show scissors for Snip n Chip, chip for Microchip Only */}
            {title === "Snip ‘n’ Chip" && (
              <img src={scissorsIcon1} alt="Scissors" style={{ height: 32, width:32, marginRight: 8 }} />
            )}
            <img src={chipImg} alt="Microchip" style={{ height: 32 ,width:32}} />
          </Box>
        </CardContent>
      </Paper>
    </ButtonBase>
  );
}

function InfoPanel({ title, items }) {
  return (
    <Box
      sx={{
        borderRadius: 2,
        p: 2,
        bgcolor: 'primary.main',
        border: 'none',
        color: '#fff',
      }}
    >
      <Typography variant="h6" fontWeight={700} gutterBottom>
        {title}
      </Typography>
      {items.map((t, i) => (
        <Typography key={i} variant="body1">
          • {t}
        </Typography>
      ))}
    </Box>
  );
}

function ShowTermsAcceptance({ acceptTerms, setAcceptTerms }) {
  const text = (
    <>
      You are confirming that you have read, understood and agreed to the{" "}
      <a href={link} referrerPolicy="no-referrer" target="_blank" rel="noreferrer">
        terms and conditions
      </a>
      .
    </>
  );
  return (
    <FormControlLabel
      control={
        <Switch
          checked={acceptTerms}
          onChange={(e) => setAcceptTerms(e.target.checked)}
        />
      }
      label={text}
    />
  );
}
